import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/file_icon.png'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page_contents" }
const _hoisted_3 = { class: "contents_div" }
const _hoisted_4 = { class: "detail_div" }
const _hoisted_5 = { class: "notice_header_div" }
const _hoisted_6 = { class: "notice_title" }
const _hoisted_7 = { class: "notice_date" }
const _hoisted_8 = { class: "notice_hits" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "notice_file_list" }
const _hoisted_11 = {
  key: 0,
  class: "notice_file_div"
}
const _hoisted_12 = {
  key: 1,
  class: "notice_file_div"
}
const _hoisted_13 = {
  key: 2,
  class: "notice_file_div"
}
const _hoisted_14 = { class: "notice_btn_div" }

import { onMounted, ref } from "vue";
import noticeAPI from "../api/noticeAPI";
import { useRouter } from "vue-router";
import { Notice, ApiResponse, Member } from "../common/types";
import { convertDate } from "../utils/utils";

export default /*@__PURE__*/_defineComponent({
  __name: 'NoticeDetailView',
  setup(__props) {

const router = useRouter();
const noticeData = ref<Notice>({
  공지순번: 0,
  제목: "",
  조회수: 0,
  내용: "",
  노출여부: "",
  작성자: {} as Member,
  첨부파일처리1: "",
  첨부파일명1: null,
  첨부파일처리2: "",
  첨부파일명2: null,
  첨부파일처리3: "",
  첨부파일명3: null,
  등록자: "",
  등록일시: "",
  수정자: "",
  수정일시: "",
  게시시작일: "",
});
onMounted(() => {
  console.log(router.currentRoute.value);
  getDetail();
});
const getDetail = () => {
  const seq = Number(router.currentRoute.value.params.seq);
  console.log(seq);
  noticeAPI.noticeDetail(seq).then((res) => {
    noticeData.value = res.data.data;
  });
};
const getFile = (공지순번: number, idx: number, 파일명: string) => {
  noticeAPI.downloadNoticeboardFile(공지순번, idx, 파일명);
};

// downloadNoticeboardFile(seq: number, index: number, filename: string) {
//         return axiosInstance.get(`/api/anonymous/noticeboards/${seq}/files/${index}`, {
//             responseType: 'blob'
//         }).then((response: any) => {
//             const url = window.URL.createObjectURL(new Blob([response]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', filename); // You can set the file name here
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//         });
//     }

const goPage = () => {
  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "page_header" }, "공지사항", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(noticeData.value.제목), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(noticeData.value.게시시작일), 1),
            _createElementVNode("div", _hoisted_8, "조회 " + _toDisplayString(noticeData.value.조회수), 1)
          ]),
          _createElementVNode("div", {
            class: "notice_contents",
            innerHTML: noticeData.value.내용
          }, null, 8, _hoisted_9),
          _createElementVNode("div", _hoisted_10, [
            (noticeData.value.첨부파일명1 != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[4] || (_cache[4] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                  _createElementVNode("div", {
                    class: "notice_file_link",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (getFile(noticeData.value.공지순번, 1, noticeData.value.첨부파일명1)))
                  }, _toDisplayString(noticeData.value.첨부파일명1), 1)
                ]))
              : _createCommentVNode("", true),
            (noticeData.value.첨부파일명2 != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _cache[5] || (_cache[5] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                  _createElementVNode("div", {
                    class: "notice_file_link",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (getFile(noticeData.value.공지순번, 2, noticeData.value.첨부파일명2)))
                  }, _toDisplayString(noticeData.value.첨부파일명2), 1)
                ]))
              : _createCommentVNode("", true),
            (noticeData.value.첨부파일명3 != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _cache[6] || (_cache[6] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                  _createElementVNode("div", {
                    class: "notice_file_link",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (getFile(noticeData.value.공지순번, 2, noticeData.value.첨부파일명3)))
                  }, _toDisplayString(noticeData.value.첨부파일명3), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "back_btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (goPage()))
            }, "목록으로")
          ])
        ])
      ])
    ])
  ]))
}
}

})